"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--blue--100,#9ebbff))",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M12 7.038a9.3 9.3 0 0 0-9.247 8.301c-.058.55.395.999.947.999h2.87c.552 0 .988-.454 1.116-.992.446-1.875 2.128-3.283 4.134-3.283s3.688 1.408 4.134 3.283c.128.538.564.992 1.116.992h3.23c.552 0 1.006-.45.947-.999A9.299 9.299 0 0 0 12 7.038"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m7.59 8.31 2.5 3.9-1.18.756-2.5-3.9zm6.32 3.9 2.5-3.9 1.18.756-2.5 3.9zm4.205.718a.7.7 0 0 0-.95-.28l-5.5 3a.7.7 0 1 0 .67 1.23l5.5-3a.7.7 0 0 0 .28-.95",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MeterThreeIcon24.js.map